<template>
    <v-col  sm="2" class="pt-0 d-block  d-md-none text-center">
        <div @click.stop="toggleSidebar(true)" style="margin-top:10px">
            <v-icon  large style="color: white;">mdi-menu</v-icon>
        </div>
        
        <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-card-title class="modal bgcolor-100">
                    <template v-if="config.mostrarLogo">
                        <img :src="logoEbook()" class="footer_logo ml-1" alt="logo" />
                    </template>
                    
                    <v-spacer></v-spacer>
                    <i @click="toggleSidebar(false)" class="icon-close" ></i>
                </v-card-title>
                <v-card-text>
                    <v-app id="inspire">
                        <v-expansion-panels multiple focusable>
                            <v-expansion-panel v-for="(lm, index) in $store.state.ebook" :key="index">
                                <v-expansion-panel-header>{{lm.nombre}}</v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                    <v-list two-line :width="'100%'" id="listResource">
                                        <v-list-item-group>
                                            <!--Primer elemento-->
                                            <v-list-item @click="dialog=false;buscarLMUnidad({lm: index, unitIndex: 0})">
                                                <v-list-item-content>
                                                    <v-list-item-title v-text="$store.state.ebook[index].nombre"></v-list-item-title>
                                                </v-list-item-content>
                                                <v-list-item-icon>
                                                    <v-icon v-text="'mdi-flag'"></v-icon>
                                                </v-list-item-icon>
                                            </v-list-item>
                                            <v-divider></v-divider>
                                            <template v-for="(unit, indexUnit) in lm.unidades">
                                                <!--LISTA DE RECURSOS-->
                                                <template v-if="unit.nombre != ''">
                                                    <v-list-item :key="unit + indexUnit" @click="dialog=false;buscarLMUnidad({lm: index,unit: unit.pagInicial, unitIndex: unit.pagInicialIndex})">
                                                        <v-list-item-content>
                                                            <v-list-item-title v-text="unit.nombre"></v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </template>
                                                

                                                <!--DIVISOR-->
                                                <v-divider v-if="index + 1 < lm.unidades.length" :key="indexUnit + unit"></v-divider>
                                                <!--FIN DIVISOR-->
                                            </template>
                                        </v-list-item-group>
                                    </v-list>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                        </v-expansion-panels>
                    </v-app>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-col>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: "Sidebar",

  components: {
 
  },

  data () {
      return {
        dialog: false,
        notifications: false,
        sound: true,
        widgets: false,
      }
    },
  methods:{
      toggleSidebar(isOpen){
          this.dialog = isOpen
      },
      logoEbook(){
        try{
            let logo = this.$store.state.ebook[this.$store.state.indexLM].logo;
            let existeImg = require("@/assets/img/" + logo); 
            return existeImg;
            } catch {
            return ''
            }
    },
      ...mapMutations(["buscarLMUnidad"]) 
  },
  computed:{
      ...mapState(['config'])
  }
};

//
</script>

<style>
.bgcolor-100{
    background: #3c3c3b;
}
.v-item-group button{
    background: white;
    color: black;
}

.v-item-group button:focus{
    opacity: .16
}

.v-item-group button:active{
    background:white;
}
</style>